import React from "react";
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton, WhatsappIcon, WhatsappShareButton
} from "react-share";
import withHeader from "../../../hocs/withHeader";

function ActiveSurveyShare(props){
    const shareUrl = props.shareUrl
    const surveyName = props.surveyName
    return <React.Fragment>
        <div className="questionaire__share">
            <div className="questionaire__share__title questionaire__share__title--mobile">
                Share
                <span className="questionaire__share__title__buble"></span>
            </div>
            <h1 className="questionaire__share__title">
                {surveyName} is now active!
            </h1>

            <h2 className="questionaire__share__subTitle">Share this survey on your favorite platform to reach more answers.
            </h2>
            <div className="questionaire__share__actions">
                <div className="questionaire__share__actions__social">
                    <CopyToClipboard text={shareUrl}>
                        <img src={require("../../../../img/surveys/icon-share.svg")} className="socialButtonLink" size={48}/>
                    </CopyToClipboard>
                    <FacebookShareButton className="socialButton" url={shareUrl}
                                         quote={surveyName} >
                        <FacebookIcon size={48} round />
                    </FacebookShareButton>
                    <TwitterShareButton className="socialButton" url={shareUrl}
                                        quote={surveyName} >
                        <TwitterIcon size={48} round />
                    </TwitterShareButton>
                    <LinkedinShareButton className="socialButton" url={shareUrl}
                                         quote={surveyName}>
                        <LinkedinIcon size={48} round />
                    </LinkedinShareButton>
                    <WhatsappShareButton className="socialButton" url={shareUrl}
                                         quote={surveyName}>
                        <WhatsappIcon size={48} round />
                    </WhatsappShareButton>
                    <EmailShareButton className="socialButton" url={shareUrl}
                                      quote={surveyName}>
                        <EmailIcon size={48} round />
                    </EmailShareButton>
                </div>
                <div className="questionaire__share__actions__link">
                    <input type="text" value={shareUrl} readOnly />
                    <CopyToClipboard className="questionaire__share__actions__link__copy" text={shareUrl}>
                        <button className="questionaire__share__actions__link__copy">
                            <span className="questionaire__share__actions__link__copy__tooltip">Copy to clipboard</span>
                            Copy link
                        </button>
                    </CopyToClipboard>
                </div>
            </div>
        </div>
    </React.Fragment>
}

export default ActiveSurveyShare;